/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Metadata_Select_LabelInputs */

const en_event_group_metadata_select_label = /** @type {(inputs: Event_Group_Metadata_Select_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select Metadata`)
};

const fr_event_group_metadata_select_label = /** @type {(inputs: Event_Group_Metadata_Select_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionner des métadonnées`)
};

const de_event_group_metadata_select_label = /** @type {(inputs: Event_Group_Metadata_Select_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadaten auswählen`)
};

const it_event_group_metadata_select_label = /** @type {(inputs: Event_Group_Metadata_Select_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona Metadati`)
};

const ru_event_group_metadata_select_label = /** @type {(inputs: Event_Group_Metadata_Select_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите метаданные`)
};

const es_event_group_metadata_select_label = /** @type {(inputs: Event_Group_Metadata_Select_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar metadatos`)
};

const zh_cn2_event_group_metadata_select_label = /** @type {(inputs: Event_Group_Metadata_Select_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择元数据`)
};

const ja_event_group_metadata_select_label = /** @type {(inputs: Event_Group_Metadata_Select_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メタデータを選択`)
};

const hi_event_group_metadata_select_label = /** @type {(inputs: Event_Group_Metadata_Select_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मेटाडेटा का चयन करें`)
};

const pt_pt2_event_group_metadata_select_label = /** @type {(inputs: Event_Group_Metadata_Select_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecionar metadados`)
};

/**
* | output |
* | --- |
* | "Select Metadata" |
*
* @param {Event_Group_Metadata_Select_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_metadata_select_label = /** @type {((inputs?: Event_Group_Metadata_Select_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Metadata_Select_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_metadata_select_label(inputs)
	if (locale === "de") return de_event_group_metadata_select_label(inputs)
	if (locale === "it") return it_event_group_metadata_select_label(inputs)
	if (locale === "ru") return ru_event_group_metadata_select_label(inputs)
	if (locale === "es") return es_event_group_metadata_select_label(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_metadata_select_label(inputs)
	if (locale === "ja") return ja_event_group_metadata_select_label(inputs)
	if (locale === "hi") return hi_event_group_metadata_select_label(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_metadata_select_label(inputs)
	return en_event_group_metadata_select_label(inputs)
});